import React from 'react';
import { Link } from 'react-router-dom';
import { List, Tag, Button, Card, Space, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_PROJECT_CATEGORIES,
  TOGGLE_DISABLED_PROJECT_CATEGORY,
} from '../../../gql/projectCategories';
import useListActions from 'hooks/useListActions';

const { Text } = Typography;

const ProjectCategories = () => {
  const { data, loading } = useQuery(GET_PROJECT_CATEGORIES, {
    variables: { state: 'ALL' },
  });
  const [toggleDisabled] = useMutation(TOGGLE_DISABLED_PROJECT_CATEGORY, {
    refetchQueries: [
      { query: GET_PROJECT_CATEGORIES, variables: { state: 'ALL' } },
      { query: GET_PROJECT_CATEGORIES },
    ],
    awaitRefetchQueries: true,
    onError: (err) => {
      console.log(err);
    },
  });

  const listActions = useListActions({
    edit: {
      url: ({ id }) => `/system-setting/project-categories/${id}/basic`,
    },
    copy: {
      url: ({ id }) => `/system-setting/project-categories/${id}/copy`,
    },
    toggleDisabled: {
      onClick: ({ id }) => {
        toggleDisabled({ variables: { id } });
      },
    },
  });

  return (
    <PageContainer
      loading={loading}
      header={{
        title: 'Project Categories',
        extra: [
          <Button key="add" type="primary">
            <Link to="/system-setting/project-categories/add">
              <PlusOutlined /> Add
            </Link>
          </Button>,
        ],
      }}
    >
      <Card bordered={false}>
        <List
          itemLayout="horizontal"
          dataSource={loading ? [] : data.projectCategories}
          pagination={{ defaultPageSize: 20, showSizeChanger: true }}
          renderItem={(item) =>
            item.deleted ? (
              ''
            ) : (
              <List.Item
                actions={listActions({ item })}
                style={{ flexWrap: 'wrap' }}
              >
                <List.Item.Meta
                  title={item.name}
                  description={`${item.workProgrammeFrom} To ${item.workProgrammeTo}`}
                  style={{ minWidth: '260px' }}
                />
                <Space size={40} style={{ minWidth: '200px' }}>
                  <Text type="secondary">Seq: {item.seq}</Text>
                  {item.disabled ? (
                    <Tag>Disabled</Tag>
                  ) : item.deleted ? (
                    <Tag color="red">Deleted</Tag>
                  ) : (
                    <Tag color="green">Active</Tag>
                  )}
                </Space>
              </List.Item>
            )
          }
        ></List>
      </Card>
    </PageContainer>
  );
};

export default ProjectCategories;
